export const ALLOW_PATTERN_NAME = '^[가-힣a-zA-Z0-9]+$';
export const ALLOW_PATTERN_CHAR = '^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|\\*]+$';
export const ALLOW_PATTERN_PASSWORD_NUMBER_AND_CHAR = '^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,}$';
export const ALLOW_PATTERN_PASSWORD =
  '(?=.*\\d{1,})(?=.*[~`!@#$%\\^&*()-+=]{0,})(?=.*[a-zA-Z]{1,}).{8,}$';
// export const ALLOW_PATTERN_EMAIL = '^[a-zA-Z0-9]+@[a-zA-Z0-9]+.[A-Za-z]+$';
export const ALLOW_PATTERN_EMAIL = '^[a-zA-Z0-9]+@[a-zA-Z0-9]+.[A-Za-z]+$';
// export const ALLOW_PATTERN_NUMBER_ONLY = '^(0|[1-9][0-9]*)$';
export const ALLOW_PATTERN_NUMBER_ONLY = '[0-9]*';
